import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
import { ToastrService } from 'ngx-toastr';

import { Client, FileResponse } from '../api/api-reference';
import { PermissionsEnum } from '../api/api-reference';
import { AppConfig } from '../config/config';
import { environment } from '../environments/environment';
import { jwtDecode } from 'jwt-decode';
import { BehaviorSubject, map, Observable, of, shareReplay, tap } from 'rxjs';

interface TokenClaims {
  email?: string;
  id?: string;
  roleId?: string;
  name?: string;
  image?: string;
  roleName?: string;
  utility?: string;
  utilityId?: string;
  isAdmin?: string; // dolazi kao "True" ili "False" jer je .NET poslao ToString()
}

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private pathApi = this.config.setting['pathApi'] + 'auth/';
  private jwtService = new JwtHelperService();

  constructor(
    private router: Router,
    private config: AppConfig,
    private client: Client,
    private readonly toastr: ToastrService,
  ) {}

  logoutClear() {
    localStorage.removeItem('token');
    localStorage.clear();
    this.router.navigate(['/login']);
  }

  isBpsAdmin() {
    const token = localStorage.getItem('token');
    if (!token) return false;

    try {
      const decoded = jwtDecode<TokenClaims>(token);
      return decoded.isAdmin == 'True';
    } catch (error) {
      console.error('Greška prilikom dekodiranja tokena', error);
      return false;
    }
  }

  getUserUtility() {
    const token = localStorage.getItem('token');
    if (!token) return null;

    try {
      const decoded = jwtDecode<TokenClaims>(token);
      return decoded.utility;
    } catch (error) {
      console.error('Greška prilikom dekodiranja tokena', error);
      return null;
    }
  }

  logout() {
    if (environment.useOpenIddict) {
      this.client.logout().subscribe({
        next: () => {
          this.logoutClear();
        },
        error: (err) => {
          this.toastr.error(err.message);
        },
      });
    } else {
      this.logoutClear();
    }
  }

  isLoggedIn() {
    const token = localStorage.getItem('token');
    if (!token) return false;

    return !this.jwtService.isTokenExpired(token);
  }

  isAuthorized(permissionRequired: PermissionsEnum[]) {
    const permissions = localStorage.getItem('permissions');
    if (!permissions) return false;

    try {
      const permissionList = this.jwtService.urlBase64Decode(permissions);
      const availablePermissions: string = JSON.parse(permissionList);
      return permissionRequired.some((element) =>
        availablePermissions.includes(element),
      );
    } catch (error) {
      console.error('Error parsing permissions from localStorage:', error);
      return false;
    }
  }
}
